import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Button, Table, Tooltip } from "@heroui/react";
import { Eye, FileText } from "lucide-react";
import { dt } from "@/shared/helper/datetime";

import {
  useAccumulators,
  useExportAccumulator,
} from "@/features/accumulators/use-accumulators.ts";
import { AccumulatorEntity } from "@/features/accumulators/types.ts";
import { accumulatorTools } from "@/shared/helper/accumulator.ts";
import { orderTools } from "@/shared/helper/order.ts";

export const Route = createFileRoute("/dashboard/order/accumulators/")({
  component: RouteComponent,
});

const DownloadButton = ({ accumulatorId }: { accumulatorId: number }) => {
  const { mutateAsync, isPending } = useExportAccumulator();

  return (
    <Tooltip>
      <Tooltip.Trigger>
        <Button
          isIconOnly
          isPending={isPending}
          variant="ghost"
          onPress={() => mutateAsync({ accumulatorId })}
        >
          {!isPending && <FileText className="size-5" />}
        </Button>
      </Tooltip.Trigger>
      <Tooltip.Content>Скачать манифест в PDF</Tooltip.Content>
    </Tooltip>
  );
};

const ViewButton = ({ accumulatorId }: { accumulatorId: number }) => {
  const navigate = useNavigate();

  return (
    <Tooltip>
      <Tooltip.Trigger>
        <Button
          isIconOnly
          variant="ghost"
          onPress={() =>
            navigate({
              to: "/dashboard/order/accumulators/$accumulatorId",
              params: { accumulatorId: String(accumulatorId) },
            })
          }
        >
          <Eye className="size-5" />
        </Button>
      </Tooltip.Trigger>
      <Tooltip.Content>Просмотреть накопитель</Tooltip.Content>
    </Tooltip>
  );
};

function RouteComponent() {
  const { data } = useAccumulators({});

  return (
    <div className="flex flex-col pt-4">
      <div className="flex flex-row gap-2 justify-between h-12 items-center">
        <p className="font-bold text-xl">Отгрузка по направлениям</p>
      </div>

      <Table.Root className="mt-8">
        <Table.Content aria-label="Отгрузка по направлениям">
          <Table.Header>
            <Table.Column>№</Table.Column>
            <Table.Column>Дата создания</Table.Column>
            <Table.Column>Откуда</Table.Column>
            <Table.Column>Куда</Table.Column>
            <Table.Column>Статус</Table.Column>
            <Table.Column> </Table.Column>
          </Table.Header>
          <Table.Body items={data.data ?? []}>
            {(accumulator: AccumulatorEntity) => (
              <Table.Row id={String(accumulator.id)}>
                <Table.Cell>
                  {orderTools.formatOrderId(accumulator.id)}
                </Table.Cell>
                <Table.Cell>
                  {dt(accumulator.createdAt).format("DD.MM.YYYY hh:mm")}
                </Table.Cell>
                <Table.Cell>{accumulator.fromCity.name}</Table.Cell>
                <Table.Cell>{accumulator.toCity.name}</Table.Cell>
                <Table.Cell>
                  {accumulatorTools.status.toString(accumulator.status)}
                </Table.Cell>
                <Table.Cell>
                  <div className="flex flex-row items-center gap-x-1">
                    <ViewButton accumulatorId={accumulator.id} />
                    <DownloadButton accumulatorId={accumulator.id} />
                  </div>
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table.Content>
      </Table.Root>
    </div>
  );
}
